import { render, staticRenderFns } from "./ImageShape.vue?vue&type=template&id=6089a1a2&scoped=true"
import script from "./ImageShape.vue?vue&type=script&lang=js"
export * from "./ImageShape.vue?vue&type=script&lang=js"
import style0 from "./ImageShape.vue?vue&type=style&index=0&id=6089a1a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6089a1a2",
  null
  
)

export default component.exports